import React from "react";
import "./Header.css";
import { Box, Dropdown, Link, Menu, MenuButton, MenuItem } from "@mui/joy";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

const Header = () => {
  const goToBills = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/bills");

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  const goToLegislators = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/legislators");

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  const goToResources = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/resources");

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  return (
    <>
      <header className="header">
        <div>
          <Link
            href="/"
            level="h3"
            underline="none"
            variant="plain"
            sx={(theme) => ({
              color: theme.vars.palette.primary[600],
            })}
            className="logo"
          >
            Civic Engage
          </Link>
        </div>
        <nav>
          <Box sx={{ display: { xs: "inline-flex", sm: "none" } }}>
            <Dropdown sx={{ display: { xs: "inline-flex", sm: "none" } }}>
              <MenuButton>
                <MenuRoundedIcon />
              </MenuButton>
              <Menu>
                <MenuItem
                  onClick={(e) => {
                    goToBills(e);
                  }}
                  level="title-md"
                  color="neutral"
                >
                  Bills & Legislation
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    goToLegislators(e);
                  }}
                  level="title-md"
                  color="neutral"
                >
                  Legislators
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    goToResources(e);
                  }}
                  level="title-md"
                  color="neutral"
                >
                  Resources
                </MenuItem>
              </Menu>
            </Dropdown>
          </Box>
          <Box sx={{ display: { xs: "none", sm: "flex" }, gap: "24px" }}>
            <Link
              href="/bills"
              level="title-md"
              sx={(theme) => ({
                color: theme.vars.palette.primary[700],
              })}
            >
              Bills & Legislation
            </Link>
            <Link
              href="/legislators"
              level="title-md"
              sx={(theme) => ({
                color: theme.vars.palette.primary[700],
              })}
            >
              Legislators
            </Link>
            <Link
              href="/resources"
              level="title-md"
              sx={(theme) => ({
                color: theme.vars.palette.primary[700],
              })}
            >
              Resources
            </Link>
          </Box>
        </nav>
      </header>
    </>
  );
};

export default Header;
